module.exports = __webpack_public_path__ + "static/mailchimp-214e3687238eeef2a93aba7b621aca81.png";